import { useEffect, useState } from "react";
import { createContactInfo, getContactInfo, updateContactInfo } from "../../../api/apiServices";


export default function ContactInfo() {
  const [contact, setContact] = useState({
    title: "",
    description: "",
    email: "",
    phone: "",
    hotlineNote: "",
    address: "",
    mapUrl: "",
    facebook: "",
    twitter: "",
    instagram: "",
    linkedin: "",
    isPublished: true,
  });

  const [contactId, setContactId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");

  /* ---------------- FETCH EXISTING CONTACT INFO ---------------- */
  useEffect(() => {
    const fetchContact = async () => {
      try {
        const res = await getContactInfo();

        if (res?.data) {
          setContact(res?.data);
          setContactId(res?.data?._id);
        }
      } catch (error) {
        console.error("Fetch Contact Error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchContact();
  }, []);

  /* ---------------- HANDLE CHANGE ---------------- */
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setContact((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  /* ---------------- SUBMIT ---------------- */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setMessage("");

    try {
      let res;

      if (contactId) {
        // UPDATE
        res = await updateContactInfo(contactId, contact);
      } else {
        // CREATE
        res = await createContactInfo(contact);
        setContactId(res._id);
      }

      setContact(res);
      setMessage("Contact information saved successfully");
    } catch (error) {
      console.error(error);
      setMessage("Failed to save contact info");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <p className="text-gray-500">Loading…</p>;

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white rounded-xl shadow">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">
        Contact Information
      </h2>

      <form onSubmit={handleSubmit} className="space-y-5">
        <input
          name="title"
          value={contact?.title}
          onChange={handleChange}
          placeholder="Section Title"
          className="input"
        />

        <textarea
          name="description"
          value={contact?.description}
          onChange={handleChange}
          rows={3}
          placeholder="Short description"
          className="input"
        />

        <input
          name="email"
          type="email"
          value={contact?.email}
          onChange={handleChange}
          placeholder="Email address"
          className="input"
        />

        <input
          name="phone"
          value={contact?.phone}
          onChange={handleChange}
          placeholder="Phone number"
          className="input"
        />

        <input
          name="hotlineNote"
          value={contact?.hotlineNote}
          onChange={handleChange}
          placeholder="Hotline note"
          className="input"
        />

        <textarea
          name="address"
          value={contact?.address}
          onChange={handleChange}
          rows={2}
          placeholder="Office address"
          className="input"
        />

        <textarea
          name="mapUrl"
          value={contact?.mapUrl}
          onChange={handleChange}
          rows={2}
          placeholder="Map Url"
          className="input"
        />

        <div className="grid sm:grid-cols-2 gap-4">
          <input
            name="facebook"
            value={contact?.facebook}
            onChange={handleChange}
            placeholder="Facebook URL"
            className="input"
          />
          <input
            name="twitter"
            value={contact?.twitter}
            onChange={handleChange}
            placeholder="Twitter / X URL"
            className="input"
          />
          <input
            name="instagram"
            value={contact?.instagram}
            onChange={handleChange}
            placeholder="Instagram URL"
            className="input"
          />
          <input
            name="linkedin"
            value={contact?.linkedin}
            onChange={handleChange}
            placeholder="LinkedIn URL"
            className="input"
          />
        </div>

        <label className="flex items-center gap-2 text-sm">
          <input
            type="checkbox"
            name="isPublished"
            checked={contact?.isPublished}
            onChange={handleChange}
          />
          Published
        </label>

        {message && (
          <p className="text-sm font-medium text-green-600">{message}</p>
        )}

        <button
          type="submit"
          disabled={saving}
          className="bg-[#6a4bc3] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#5a3ba3] disabled:opacity-50"
        >
          {saving ? "Saving..." : "Save Contact Info"}
        </button>
      </form>

      
    </div>
  );
}
